<template>
    <v-runtime-template :template="MyClimateDescriptionText" />
</template>

<script>
    import VRuntimeTemplate from "v-runtime-template";    

    export default {
        computed: {
            Strings() {
                return this.$migrolVueLibraryData.Strings;
            },
            Settings() {
                return this.$migrolVueLibraryData.Settings;
            },
            MyClimateDescriptionText() {
                return this.Strings['Global.MyClimateDescription'];
            },
            MyClimateLink() {
                return this.Settings['myClimateUrl'];
            }
        },
        components: {
            VRuntimeTemplate
        }
    };
</script>